import "./style.scss";
import { FC } from "react";
import DocumentSvg from "@/src/svg/applicationsPage/APPopUp/Documents/DocumentSvg";

interface DocumentPreviewPlaceholderProps {
  label: string;
  className?: string;
}

const DocumentPreviewPlaceholder: FC<DocumentPreviewPlaceholderProps> = ({ label, className = "" }) => {
  return (
    <div className={`document-preview-placeholder ${className}`.trim()}>
      <div className="document-preview-placeholder-card">
        <DocumentSvg />
        <span>{label}</span>
      </div>
    </div>
  );
};

export default DocumentPreviewPlaceholder;
